export default __webpack_public_path__ + "static/media/hundred_bp_dna_ladder_marker.c28bfc97.svg";